import { render, staticRenderFns } from "./collateral-list.vue?vue&type=template&id=911545b2&scoped=true"
import script from "./collateral-list.vue?vue&type=script&lang=js"
export * from "./collateral-list.vue?vue&type=script&lang=js"
import style0 from "./collateral-list.vue?vue&type=style&index=0&id=911545b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911545b2",
  null
  
)

export default component.exports